import { InputGroupProps, useBreakpointValue } from '@chakra-ui/react';
import { useEffect, useRef } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { SearchInput } from '~/components/SearchInput';
import { useSearchTalentStore } from '~/screens/MyAgency/store';
import { convertPxToRems } from '~/utils-ts';

interface ISearchTalentProps {
  inputGroupProps?: InputGroupProps;
}

export const SearchTalent: React.FC<ISearchTalentProps> = ({
  inputGroupProps,
}) => {
  const isBelowSmallScreens = useBreakpointValue({ base: true, sm: false });
  const { query, setQuery, clearQuery } = useSearchTalentStore();

  useEffect(() => {
    return () => {
      clearQuery();
    };
  }, [clearQuery]);

  const inputRef = useRef<HTMLInputElement>(null);

  useHotkeys(
    'ctrl+f, meta+f',
    () => {
      inputRef.current?.focus();
    },
    { preventDefault: true },
  );

  return (
    <SearchInput
      onChange={(value) => {
        setQuery(value as string);
      }}
      inputGroupProps={{
        width: isBelowSmallScreens ? '100%' : convertPxToRems(200),
        marginY: isBelowSmallScreens ? 4 : 0,
        ...inputGroupProps,
      }}
      inputProps={{
        id: 'searchTalentId',
        name: 'searchTalent',
        placeholder: `Search by keyword`,
      }}
      iconProps={{
        color: 'primary.300',
      }}
      defaultValue={query}
      ref={inputRef}
    />
  );
};
